// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsDetailsOptionsStyles } from "@guestsupply/Overrides/Widgets/MyListsDetails/MyListsDetailsOptions";
import Close from "@guestsupply/XDL/Icons/Close";
import Plus from "@guestsupply/XDL/Icons/Plus";
import { color, hideElementOnPrint, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import { css } from "styled-components";

myListsDetailsOptionsStyles.wrapper = {
    css: css`
        ${hideElementOnPrint}
        display: flex;
        margin: 20px 0;
        padding: 15px;
        border: 1px solid ${color("common.border")};
    `,
};
myListsDetailsOptionsStyles.leftColumnWrapper = {
    css: css`
        display: flex;
        width: 100%;
        gap: 10px;
        ${xScreen("gt", "md")} {
            align-items: end;
        }
        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};
myListsDetailsOptionsStyles.container = {
    gap: 20,
};
myListsDetailsOptionsStyles.searchGridItem = { width: [12, 8, 6, 4, 4] };
myListsDetailsOptionsStyles.search = {
    iconProps: {
        src: Search,
        color: "common.ui7",
    },
};
myListsDetailsOptionsStyles.sortByGridItem = {
    width: [12, 4, 3, 2, 2],
};
myListsDetailsOptionsStyles.selectAllGridItem = {
    width: [12, 8, 6, 3, 3],
    css: css`
        align-items: end;
        ${xScreen("gt", "sm")} {
            padding-bottom: 22px;
        }
    `,
};
myListsDetailsOptionsStyles.selectAllWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
    `,
};
myListsDetailsOptionsStyles.addItemsGridItem = {
    width: [12, 4, 6, 3, 3],
    css: css`
        align-items: flex-end;
        justify-content: flex-end;
        ${xScreen("lte", "xs")} {
            justify-content: flex-start;
        }
    `,
};
myListsDetailsOptionsStyles.addItemsButton = {
    variant: "primary",
    icon: {
        src: Plus,
        position: "right",
    },
    css: css`
        align-items: baseline;
        white-space: nowrap;
        padding: 8px 20px;
        height: 36px;
        ${xScreen("lte", "sm")} {
            width: 100%;
        }
        ${IconWrapper} {
            top: 3px;
            width: 10px;
            height: 10px;
        }
    `,
};
myListsDetailsOptionsStyles.uploadItemsModal = {
    sizeVariant: "large",
};
myListsDetailsOptionsStyles.actionsWrapper = {
    css: css`
        display: inline-flex;
        align-items: flex-end;
        gap: 10px;
        ${xScreen("lte", "sm")} {
            align-items: flex-end;
            justify-content: space-between;
            margin-top: 10px;
        }
    `,
};
myListsDetailsOptionsStyles.uploadItemsButton = {
    variant: "secondary",
    css: css`
        white-space: nowrap;
        padding-block: 9px;
    `,
};
myListsDetailsOptionsStyles.closeButton = {
    variant: "secondary",
    icon: {
        src: Close,
        position: "left",
    },
    css: css`
        padding: 9px 10px;
        white-space: nowrap;
        transition: all 200ms ease-in-out;
        &,
        &:hover,
        &:focus {
            border: transparent;
        }
        ${IconWrapper} {
            top: 3px;
            width: 12px;
            height: 12px;
            svg {
                color: ${color("primary")};
            }
        }
        &:hover {
            ${IconWrapper} svg {
                color: ${color("common.ui8")};
            }
        }
        &:focus {
            ${IconWrapper} svg {
                color: ${color("common.ui9")};
            }
        }
    `,
};
myListsDetailsOptionsStyles.actionButtonsHidden = {
    css: css`
        ${xScreen("lte", "sm")} {
            margin-top: 20px;
        }
    `,
};
myListsDetailsOptionsStyles.productSelectorStyles = {
    container: {
        gap: 10,
        offsetCss: css`
            row-gap: 5px;
        `,
    },
    buttonGridItem: {
        width: [12, 5, 3, 3, 3],
        css: css`
            justify-content: start;
            align-items: end;
            &&&& {
                ${xScreen("lte", "sm")} {
                    max-width: none;
                    flex: 1;
                }
            }
        `,
    },
    selectButton: {
        css: css`
            padding-block: 9px;
            margin-top: 0;
            margin-bottom: 0;
            &&&& {
                ${xScreen("lte", "sm")} {
                    margin-top: 0;
                    min-width: 150px;
                }
            }
        `,
    },
    unitOfMeasureGridItem: {
        width: [5, 4, 3, 3, 3],
        css: css`
            &:empty {
                display: none;
            }
            &&& {
                ${xScreen("lte", "sm")} {
                    max-width: none;
                    min-width: 100px;
                    flex: 1;
                }
            }
        `,
    },
    clearIcon: {
        css: css`
            top: 32px;
            &:hover {
                color: ${color("common.ui8")};
            }
        `,
    },
};

myListsDetailsOptionsStyles.editSortOrder = {
    css: css`
        cursor: pointer;
    `,
};
